import { formatStepKey } from '@/components/Event/NewScript/utils/stepKey'
import { ScriptStep } from '@/constants'

export const getNextClosingStep = ({
  eventCount,
  witnessIndex,
}: {
  eventCount: number
  witnessIndex: number | undefined
}): string => {
  if (witnessIndex === undefined || witnessIndex >= eventCount - 1) {
    return ScriptStep.REVIEW
  }

  return formatStepKey(ScriptStep.ATTENDANCE, witnessIndex + 1)
}
